//  @flow
import DropOffPage from './DropOffPage';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import type { State } from 'types/redux';
import type { Props } from './DropOffPage';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import {
  setTransportationInfo,
  sendTransportationOptionsShown,
  sendTransportationOptionsFinish
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getTransportationOption,
  getRedirectedToDropoff
} from 'store/reducers/appointment/selectors';
import {
  getTransportOptions,
  isValetAvailable
} from 'store/reducers/apptOptions/selectors';
import {
  getCTABanner,
  showProgressBar,
  hideBottomCTA
} from 'store/reducers/optimizelyABTest/selectors';

import { errorLoadingAdvisors } from 'store/reducers/errors/selectors';
import { currentPath, previousPath } from 'store/reducers/navigation/selectors';

const mapStateToProps = (state: State): $Shape<Props> => ({
  transportationOption: getTransportationOption(state),
  transportations: getTransportOptions(state),
  isValetAvailable: isValetAvailable(state),
  noAdvisorsError: errorLoadingAdvisors(state),
  currentPath: currentPath(state),
  previousPath: previousPath(state),
  ctaBanner: getCTABanner(state),
  showProgressBar: showProgressBar(state),
  hideBottomCTA: hideBottomCTA(state),
  redirectedTo: getRedirectedToDropoff(state)
});

export default compose(
  withRouter,
  injectIntl,
  connect(
    mapStateToProps,
    {
      goTo,
      setTransportationInfo,
      gtmUserEvent,
      sendTransportationOptionsShown,
      sendTransportationOptionsFinish
    }
  )
)(DropOffPage);



// WEBPACK FOOTER //
// ./src/components/pages/DropOffPage/DropOffPageContainer.js